import { z } from 'zod';
import { ErrorResponseSchema } from '@/schemas/common/base';

/** The listing id from the URL path. */
export const NsfwListingParamSchema = z.object({
  id: z.string().regex(/^\d+$/, 'Invalid listing ID'),
});

/** true: keep it out of every row and browse page. false: show it again, whatever Jev said. */
export const NsfwListingBodySchema = z.object({
  nsfw: z.boolean(),
});

export const NsfwListingSuccessResponseSchema = z.object({
  success: z.literal(true),
  nsfw: z.boolean(),
});

export const NsfwListingResponseSchema = z.discriminatedUnion('success', [
  NsfwListingSuccessResponseSchema,
  ErrorResponseSchema,
]);

export type NsfwListingResponse = z.infer<typeof NsfwListingResponseSchema>;

/**
 * GET: whether the listing is hidden now, and who decided. `source` is 'admin'
 * for an admin's call, Jev's kind for Jev's, null when nobody has judged it.
 */
export const NsfwListingStateSuccessResponseSchema = z.object({
  success: z.literal(true),
  nsfw: z.boolean(),
  source: z.string().nullable(),
});

export const NsfwListingStateResponseSchema = z.discriminatedUnion('success', [
  NsfwListingStateSuccessResponseSchema,
  ErrorResponseSchema,
]);

export type NsfwListingStateResponse = z.infer<typeof NsfwListingStateResponseSchema>;
